const firstChar = 0;

export const getUserInitials = (firstName?: string, lastName?: string) => {
  return (
    (firstName?.length ? firstName.charAt(firstChar) : '') +
    (lastName?.length ? lastName.charAt(firstChar) : '')
  );
};
